import ConstructorIOClient from '@constructor-io/constructorio-client-javascript';

let constructorio = new ConstructorIOClient({
    apiKey: process.env.REACT_APP_CONSTRUCTOR_ENV_KEY.trimEnd()
});

/** Need a separate Constructor object for Book-a-like
 *  since the stage key does not return any recommendations
 */
export let recommendationsConstructor = new ConstructorIOClient({
    apiKey: process.env.REACT_APP_CONSTRUCTOR_PROD_KEY.trimEnd()
})

// Pod name for Constructor recommendations module
export const constructorPod = "tso_product_page_2"

export default constructorio